let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("92XsH")).then(() => parcelRequire('iWLFa'));